import { CLOSE_SHARE_BOX, OPEN_SHARE_BOX } from '../../constants/ShareConstants'
import { updateQuest } from './QuestActions'

export const OpenShareBox = props => dispatch => {
  dispatch(updateQuest(1))

  dispatch({
    type: OPEN_SHARE_BOX,
    id: props.id,
    imgUrl: props.imgUrl,
    shareType: props.shareType,
    customUrl: props.customUrl ? props.customUrl : null
  })
}

export function CloseShareBox() {
  return {
    type: CLOSE_SHARE_BOX
  }
}
